import { FC } from 'react'
import { Stack, Typography } from '@mui/material'
import { useTranslate } from 'react-admin'

interface DetailFieldProps {
  label: string
  children: React.ReactNode
  direction?: 'row' | 'column'
}

export const DetailField: FC<DetailFieldProps> = ({ label, children, direction = 'column' }) => {
  const translate = useTranslate()

  return (
    <Stack direction={direction} spacing={direction === 'row' ? 1 : 0.5} alignItems={direction === 'row' ? 'center' : 'flex-start'}>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 500,
          color: 'rgba(0,0,0,0.45)',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          whiteSpace: 'nowrap',
        }}
      >
        {translate(label, { _: label })}
      </Typography>
      {children}
    </Stack>
  )
}
